<script setup lang="ts">
/**
 * CaKontak — blok kanal kontak untuk halaman kebijakan, tema v3.
 * Pasangan v3 dari components/KontakBantuan.vue.
 *
 * Seluruh blok menghilang bila pemilik belum mengisi satu pun kanal kontak
 * (lihat composables/useIdentitas.ts), sehingga halaman tidak pernah
 * menjanjikan bantuan lewat kanal yang tidak ada.
 */
const props = withDefaults(
  defineProps<{
    /** Nama halaman asal, ikut dikirim di pesan awal WhatsApp. */
    konteks?: string
    /** Kalimat pembuka WhatsApp. */
    pesan?: string
    /** Subjek email. */
    subjek?: string
  }>(),
  { konteks: '', pesan: '', subjek: 'Bantuan tools.coreasia.id' }
)

const identitas = useIdentitas()
</script>

<template>
  <div v-if="identitas.adaKontak" class="flex flex-col sm:flex-row flex-wrap gap-3">
    <CaButton
      v-if="identitas.adaWa"
      variant="secondary"
      size="lg"
      icon="i-lucide-message-circle"
      :href="identitas.tautanWa({ pesan: props.pesan || undefined, konteks: props.konteks || undefined })"
    >Chat WhatsApp</CaButton>

    <CaButton
      v-if="identitas.adaEmail"
      variant="secondary"
      size="lg"
      icon="i-lucide-mail"
      :href="identitas.tautanEmail(props.subjek)"
    >Email {{ identitas.email }}</CaButton>
  </div>
</template>
